/* Ethos özel sıralama bileşeni — aç/kapa mantığı.
   Masaüstü: tetik butonu dropdown'ı açar/kapatır; dışarı tıklama + ESC kapatır.
   Mobil: .mobile-filter-bar 'SIRALA' butonu (#MobileSortTrigger) alt sheet'i açar.
   Seçenekler <a href="?sort_by=..."> — tıklayınca sayfa yönlenir (JS gerekmez). */
(function () {
  'use strict';

  // Çift yükleme koruması: hem banner hem facets bu script'i yükleyebilir.
  if (window.__ethosSortInit) return;
  window.__ethosSortInit = true;

  function isMobile(menu) {
    return menu.classList.contains('ethos-sort--mobile');
  }

  function openMenu(menu) {
    var panel = menu.querySelector('.ethos-sort__panel');
    var overlay = menu.querySelector('.ethos-sort__overlay');
    if (panel) panel.hidden = false;
    if (overlay) overlay.hidden = false;
    // display:none'dan çıktıktan sonra transition çalışsın diye reflow zorla
    void menu.offsetWidth;
    menu.classList.add('is-open');
    var toggle = menu.querySelector('[data-sort-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (isMobile(menu)) document.documentElement.style.overflow = 'hidden';
  }

  function closeMenu(menu) {
    if (!menu.classList.contains('is-open')) return;
    menu.classList.remove('is-open');
    var toggle = menu.querySelector('[data-sort-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';

    var panel = menu.querySelector('.ethos-sort__panel');
    var overlay = menu.querySelector('.ethos-sort__overlay');

    if (isMobile(menu) && panel) {
      // slide-down bitince gizle
      var done = function () {
        panel.hidden = true;
        if (overlay) overlay.hidden = true;
        panel.removeEventListener('transitionend', done);
      };
      panel.addEventListener('transitionend', done);
      setTimeout(done, 340); // fallback
    } else {
      if (panel) panel.hidden = true;
      if (overlay) overlay.hidden = true;
    }
  }

  function toggleMenu(menu) {
    if (menu.classList.contains('is-open')) closeMenu(menu);
    else openMenu(menu);
  }

  function init() {
    var menus = document.querySelectorAll('.ethos-sort');
    Array.prototype.forEach.call(menus, function (menu) {
      if (menu.dataset.sortInit) return;
      menu.dataset.sortInit = '1';

      var toggle = menu.querySelector('[data-sort-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function (e) {
          e.stopPropagation();
          toggleMenu(menu);
        });
      }

      Array.prototype.forEach.call(menu.querySelectorAll('[data-sort-close]'), function (el) {
        el.addEventListener('click', function () {
          closeMenu(menu);
        });
      });
    });

    // Masaüstü: dışarı tıklama kapatır
    document.addEventListener('click', function (e) {
      Array.prototype.forEach.call(
        document.querySelectorAll('.ethos-sort--desktop.is-open'),
        function (menu) {
          if (!menu.contains(e.target)) closeMenu(menu);
        }
      );
    });

    // ESC tüm açık menüleri kapatır
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        Array.prototype.forEach.call(document.querySelectorAll('.ethos-sort.is-open'), closeMenu);
      }
    });

    // Mobil alt çubuktaki SIRALA → kırmızı alt sheet'i aç
    var mobileTrigger = document.getElementById('MobileSortTrigger');
    var mobileMenu = document.getElementById('EthosSortMobile');
    if (mobileTrigger && mobileMenu) {
      mobileTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openMenu(mobileMenu);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
